import React from "react";
// import { Link as Link2 } from "react-router-dom";
import AboutImage from "../assets/images/tgsc.png";

// import ModalVideo from "react-modal-video";
// import "../../node_modules/react-modal-video/scss/modal-video.scss";


export default function About() {
  // const [isOpen, setOpen] = useState(false)

  return (
    <>
      <section
        className="relative py-16 md:py-24 bg-gray-50 dark:bg-slate-800"
        id="about"
      >
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 gap-10 items-center">
            {/* Image Section */}
            <div className="lg:col-span-5">
              <div className="relative">
                <img
                  src={AboutImage}
                  className="rounded-lg shadow-lg relative lg:-mt-[137px] -mt-10 w-full"
                  alt="About Us"
                />
              </div>
            </div>
            {/* End Image Section */}

            {/* Content Section */}
            <div className="lg:col-span-7">
              <div className="lg:ml-7">
                <h6 className="text-[#69A41D] font-medium text-[16px] uppercase mt-10 lg:mt-24 mb-2">
                  Introduction
                </h6>

                <h3 className="mb-4 mt-2 text-[#18443A] text-[28px] md:text-[32px] lg:text-[40px] font-semibold">
                  Our Company Story
                </h3>

                <p className="text-slate-400 mt-6 dark:text-slate-300 text-[14px] md:text-[16px] max-w-full lg:max-w-2xl">
                  At The Green Space, we manufacture Heat Treated Wooden
                  Pallets, Boxes, Crates, and Heavy Duty Corrugation Packaging
                  as per ISPM standards. We provide customized industrial and
                  on-site packaging solutions with assured quality, durability,
                  and timely delivery for domestic and export industries.
                </p>

                {/* Tick Mark Points */}
                <div className="mt-6 space-y-3">
                  <div className="flex items-center gap-3">
                    <img src="/checkmark.svg" alt="check" className="w-5 h-5" />
                    <span className="text-slate-600 text-[15px] md:text-[16px]">
                      ISPM Certified Heat Treated Products
                    </span>
                  </div>

                  <div className="flex items-center gap-3">
                    <img src="/checkmark.svg" alt="check" className="w-5 h-5" />
                    <span className="text-slate-600 text-[15px] md:text-[16px]">
                      Heavy Duty Corrugation & On-Site Packaging
                    </span>
                  </div>

                  <div className="flex items-center gap-3">
                    <img src="/checkmark.svg" alt="check" className="w-5 h-5" />
                    <span className="text-slate-600 text-[15px] md:text-[16px]">
                      Timely Delivery & Quality Assurance
                    </span>
                  </div>
                </div>

                <div className="relative mt-6">
                  <a
                    href="#portfolio"
                    className="inline-block btn text-white rounded-md text-[16px] font-bold px-6 py-3"
                    style={{
                      backgroundColor: "#18443A",
                      borderColor: "#18443A",
                    }}
                  >
                    View Portfolio
                  </a>
                </div>
              </div>
            </div>
            {/* End Content Section */}
          </div>
        </div>
      </section>
    </>
  );
}
